import request from "../utils/request";

export const list = (data) => request.post("/api/order", data);
export const get = (id) => request.get(`/api/order/${id}`);
export const cancel = (data) => request.post("/api/order/cancel", data);
export const verify = (data) => request.post("/api/order/verify", data);
export const close = (data) => request.post("/api/order/close", data);
export const unnecessary = (data) => request.post("/api/order/unnecessary", data);
export const preview = (data) => request.post("/api/order/preview", data);
export const receipt = (id, data) => request.post(`/api/order/receipt/${id}`, data);
export const adminCreate = (data) => request.post("/api/order/admin-create", data);